// @flow @format
import React, {PureComponent, type Node} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import RepositorySelectContainer from '../../../../containers/RepositorySelectContainer';
import BreadcrumbContainer from '../../../../containers/BreadcrumbContainer';
import DownloadHistoryContainer from '../../../../containers/DownloadHistoryContainer';
import LoadingIcon from '../../../../components/Icon/circle-o-notch';
import Tooltip from '../../../../components/Tooltip';
import Drawer from '../../../../components/Drawer';
import Modal from '../../../../components/Modal';
import UserIcon from '../../../../components/Icon/user';
import ChartIcon from '../../../../components/Icon/pie-chart';
import {closeHistory} from '../../../../reducers/history';
import {toggleFilesDeleted} from '../../../../reducers/entities/files';
import classNames from 'lib/classnames';
import FileList, {
	FileListHeader,
	FileListHeaderRow,
} from '../../../../components/FileList';
import {toSIString} from 'lib/util';

import './FilesLayout.css';

import type {State} from '../../../../reducers';

type Props = {
	children?: Node,
	subscribed: boolean,
	historyVisibility: boolean,
	closeHistory: typeof closeHistory,
	location: {pathname: string},
	loading: boolean,
	showDeleted: boolean,
	toggleFilesDeleted: () => void,
	grantedBytes: number,
	usedBytes: number,
	user: string,
};

const PermissionModal = ({visible}: {visible: boolean}) =>
	<Modal visible={visible} onClose={() => {}}>
		<div className="DownloadConfirmation">
			<h2>Autorización</h2>
			<p>
				Para poder utilizar esta aplicación, debe autorizarla haciendo
				click en permitir en el cuadro de arriba a la izquierda.
			</p>
		</div>
	</Modal>;

class Label extends PureComponent<{
	children?: Node,
	tooltip: string,
}> {
	static style = {
		color: 'gray',
		margin: '0 calc(var(--baseline) / 2)',
		padding: 'calc(var(--baseline) / 4) calc(var(--baseline) / 2)',
		fontSize: 'var(--sm-text)',
		backgroundColor: 'var(--background-secondary-color)',
		borderRadius: 5,
	};

	overlay: React$Element<*>;

	componentWillMount() {
		this.overlay = <span>{this.props.tooltip}</span>;
	}

	render() {
		return (
			<Tooltip placement="top" overlay={this.overlay}>
				<p style={Label.style}>
					{this.props.children}
				</p>
			</Tooltip>
		);
	}
}

class UserLabel extends PureComponent<{
	user: string,
}> {
	static icon = <UserIcon />;

	render() {
		return (
			<Label tooltip="Usuario">
				{UserLabel.icon} {this.props.user}
			</Label>
		);
	}
}

class UsageLabel extends PureComponent<{
	usedBytes: number,
	grantedBytes: number,
}> {
	static icon = <ChartIcon />;

	render() {
		const {usedBytes, grantedBytes} = this.props;
		return (
			<Label tooltip="Espacio disponible">
				{UsageLabel.icon}
				{' '}
				{`${toSIString(usedBytes)}/${toSIString(grantedBytes)}`}
			</Label>
		);
	}
}

function FilesLayout({
	children,
	location,
	loading,
	historyVisibility,
	subscribed,
	closeHistory,
	toggleFilesDeleted,
	showDeleted,
	grantedBytes,
	usedBytes,
	user,
}: Props) {
	return (
		<div>
			<section className="FilesLayout">
				<FileList>
					<FileListHeader>
						<FileListHeaderRow
							style={{justifyContent: 'flex-start'}}
						>
							<UserLabel user={user} />
							<UsageLabel
								usedBytes={usedBytes}
								grantedBytes={grantedBytes}
							/>
						</FileListHeaderRow>

						{location.pathname !== '/explorer' &&
							<FileListHeaderRow>
								<RepositorySelectContainer />
								<BreadcrumbContainer />
								{loading &&
									<LoadingIcon
										className="rotate-animation"
										style={{
											margin:
												'0 calc(var(--baseline) * 2)',
											fontSize: 'var(--lg-text)',
											minWidth: 'var(--baseline)',
										}}
									/>}
								<div
									className={classNames({
										FilesLayout__Switch: true,
										'FilesLayout__Switch--Active': showDeleted,
									})}
									onClick={toggleFilesDeleted}
								>
									<input
										type="checkbox"
										checked={showDeleted}
									/>
									Ver eliminados
								</div>
							</FileListHeaderRow>}
					</FileListHeader>
					{children}
				</FileList>
			</section>

			<Drawer
				active={historyVisibility}
				onOverlayClick={() => {
					closeHistory();
				}}
			>
				<DownloadHistoryContainer />
			</Drawer>

			<PermissionModal visible={!subscribed} />
		</div>
	);
}

FilesLayout.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node),
	]).isRequired,
	historyVisibility: PropTypes.bool.isRequired,
	loading: PropTypes.bool.isRequired,
	showDeleted: PropTypes.bool.isRequired,
	grantedBytes: PropTypes.number.isRequired,
	usedBytes: PropTypes.number.isRequired,
	user: PropTypes.string.isRequired,
};

const mapStateToProps = (state: State) => {
	const user = state.entities.users.entities[state.session.user];
	return {
		historyVisibility: state.history.visible,
		loading: !!!state.entities.files.entities[state.selection.fileNodeId],
		showDeleted: state.entities.files.showDeleted,
		subscribed: state.entities.downloads.subscribed,
		grantedBytes: state.entities.downloads.grantedBytes,
		usedBytes: state.entities.downloads.usedBytes,
		user: user ? user.name : state.session.user,
	};
};

const mapDispatchToProps = {
	closeHistory,
	toggleFilesDeleted,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilesLayout);



// WEBPACK FOOTER //
// ./src/routes/Explorer/layouts/FilesLayout/FilesLayout.js